export interface RelatedServiceContractFormData {
  agencyRelatedServiceContractSk: string;
  agencySk: string;
  contractSk: string;
  schoolType: string;
  languageId: string;
  disciplineId: string;
  borough: string;
  district: string;
  awardedTierId: string;
  awardedPrice: string;
  orderOfUse: string;
  effectiveStartDate: string;
  effectiveEndDate: string;
  contactName: string;
  contactEmail: string;
  contactTitle: string;
  contactPhone: string;
  agencyLocationSk: string;
}

export class SaveRelatedServiceContractModel {
  agencyRelatedServiceContractSk: string;
  agencySk: string;
  contractSk: string;
  schoolType: string;
  languageId: string;
  disciplineId: string;
  borough: string;
  district: string;
  awardedTierId: string;
  awardedPrice: string;
  orderOfUse: string;
  effectiveStartDate: string;
  effectiveEndDate: string;
  contactName: string;
  contactEmail: string;
  contactTitle: string;
  contactPhone: string;
  agencyLocationSk: string;

  constructor(data: RelatedServiceContractFormData) {
    this.agencyRelatedServiceContractSk = data?.agencyRelatedServiceContractSk;
    this.agencySk = data?.agencySk;
    this.contractSk = data?.contractSk;
    this.schoolType = data?.schoolType;
    this.languageId = data?.languageId;
    this.disciplineId = data?.disciplineId;
    this.borough = data?.borough;
    this.district = data?.district;
    this.awardedTierId = data?.awardedTierId;
    this.awardedPrice = data?.awardedPrice;
    this.orderOfUse = data?.orderOfUse;
    this.effectiveStartDate = data?.effectiveStartDate;
    this.effectiveEndDate = data?.effectiveEndDate;
    this.contactName = data?.contactName;
    this.contactEmail = data?.contactEmail;
    this.contactTitle = data?.contactTitle;
    this.contactPhone = data?.contactPhone;
    this.agencyLocationSk = data?.agencyLocationSk;
  }
}
